import { createAction } from 'redux-actions';

export const openAddParticipantsDrawerAction = createAction('DRAWERS/OPEN_ADD_PARTICIPANTS_DRAWER');
export const requestGetUserParticipantsListAction = createAction(
  'REQUEST/GET_USER_PARTICIPANTS_LIST',
);
